<template>
  <div class="tab-pane-inner llm-intention-tag-tab">
    <div class="intent-mode-switch-wrap">
      <button
        type="button"
        class="intent-mode-btn"
        :class="{ 'is-active': effectiveMode === INTENT_TAG_MODE.REGULAR }"
        @click="setMode(INTENT_TAG_MODE.REGULAR)"
      >
        常规模式
      </button>
      <button
        type="button"
        class="intent-mode-btn"
        :class="{ 'is-active': effectiveMode === INTENT_TAG_MODE.FORCED }"
        @click="setMode(INTENT_TAG_MODE.FORCED)"
      >
        强制抽取
      </button>
    </div>

    <RegularModePanel
      v-if="effectiveMode === INTENT_TAG_MODE.REGULAR"
      :intent-tag="intentTag"
    />
    <ForcedExtractionPanel
      v-else
      :intent-tag="intentTag"
      :scene-name="sceneName"
    />
  </div>
</template>

<script>
import { INTENT_TAG_MODE } from '../../constants/intentTag'
import { ensureForcedSystemExtractFields } from '../../utils/intentTagHelpers'
import RegularModePanel from './RegularModePanel.vue'
import ForcedExtractionPanel from './ForcedExtractionPanel.vue'

export default {
  name: 'LlmIntentionTagTab',
  components: {
    RegularModePanel,
    ForcedExtractionPanel,
  },
  props: {
    intentTag: {
      type: Object,
      required: true,
    },
    sceneName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      INTENT_TAG_MODE,
    }
  },
  computed: {
    effectiveMode() {
      const mode =
        this.intentTag && this.intentTag.mode != null
          ? String(this.intentTag.mode).trim().toLowerCase()
          : ''
      if (mode === INTENT_TAG_MODE.FORCED || mode === 'forced_extraction') {
        return INTENT_TAG_MODE.FORCED
      }
      return INTENT_TAG_MODE.REGULAR
    },
  },
  mounted() {
    this.ensureIntentTagShape()
  },
  methods: {
    ensureIntentTagShape() {
      if (!this.intentTag.mode) {
        this.$set(this.intentTag, 'mode', INTENT_TAG_MODE.REGULAR)
      }
      if (this.intentTag.extractFormName == null) {
        this.$set(this.intentTag, 'extractFormName', '')
      }
      if (this.intentTag.extractFormId == null) {
        this.$set(this.intentTag, 'extractFormId', '')
      }
      if (!Array.isArray(this.intentTag.rules)) {
        this.$set(this.intentTag, 'rules', [])
      }
      if (!Array.isArray(this.intentTag.extractFields)) {
        this.$set(this.intentTag, 'extractFields', [])
      }
      if (!Array.isArray(this.intentTag.ratingRules)) {
        this.$set(this.intentTag, 'ratingRules', [])
      }
      if (this.effectiveMode === INTENT_TAG_MODE.FORCED) {
        ensureForcedSystemExtractFields(this.intentTag)
      }
    },
    setMode(mode) {
      this.ensureIntentTagShape()
      this.$set(
        this.intentTag,
        'mode',
        mode === INTENT_TAG_MODE.FORCED ? INTENT_TAG_MODE.FORCED : INTENT_TAG_MODE.REGULAR,
      )
      if (mode === INTENT_TAG_MODE.FORCED) {
        ensureForcedSystemExtractFields(this.intentTag)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.llm-intention-tag-tab {
  width: 100%;
  max-width: 100%;
}

.intent-mode-switch-wrap {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 37px;
  margin-bottom: 16px;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
  background: #f5f7fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.intent-mode-btn {
  border: none;
  background: transparent;
  color: #909399;
  font-size: 13px;
  line-height: 1.4;
  padding: 0 20px;
  cursor: pointer;
  flex: 0 0 auto;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover:not(.is-active) {
    color: #1e293b;
  }

  &.is-active {
    background: #5668f0;
    color: #fff;
    font-weight: 400;
  }

  &:first-child.is-active {
    border-radius: 3px 0 0 3px;
  }

  &:last-child.is-active {
    border-radius: 0 3px 3px 0;
  }
}
</style>
